module.exports = __webpack_public_path__ + "img/close-circle.214f2ca7.svg";